// 幣別正規化：把 callsite 帶的非 ISO 4217 / 千單位 currency 轉成 GA4/FB/TikTok/Kwai
// 認得的標準 ISO 碼，必要時同步調整 value / app_value 為基本單位。
//
// 加新幣別只要在這張表加一列：
//   { iso: '<ISO 4217>', multiply: <每單位幾個基本單位> }
//
// 注意：Bridge / Native 端在 dispatcher 仍會收到「轉換前」的 objData（C7 deferred 議題）。
export const CURRENCY_NORMALIZE = {
  VNDK: { iso: 'VND', multiply: 1000 }, // ₫ 千單位 → 基本單位
  IDRK: { iso: 'IDR', multiply: 1000 }, // Rp 千單位 → 基本單位
  USDT: { iso: 'USD', multiply: 1 }, //    加密穩定幣 → USD ISO（GA4 才認）
}

/**
 * 傳入 event payload（已含 currency / value / app_value），回傳新物件（不 mutate input）。
 * 若 currency 不在 CURRENCY_NORMALIZE 表內，回傳原 payload 的 shallow copy（一致性語意）。
 *
 * @param {Object} objData callsite payload，需含 currency 欄位才會處理
 * @returns {Object} 新物件，可能 currency / value / app_value 已調整
 */
export function normalizeCurrency(objData) {
  if (!objData || typeof objData !== 'object') return objData
  const norm = CURRENCY_NORMALIZE[objData.currency]
  if (!norm) return { ...objData }
  const out = { ...objData }
  if (norm.multiply !== 1) {
    if (objData.value !== undefined && objData.value !== null) {
      out.value = Number(objData.value) * norm.multiply
    }
    if (objData.app_value !== undefined && objData.app_value !== null) {
      out.app_value = Number(objData.app_value) * norm.multiply
    }
  }
  out.currency = norm.iso
  return out
}
